import { Link } from 'react-router-dom';
import { AlertCircle, Home } from 'lucide-react';

export function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-gradient-to-br from-bg via-blue-dark/30 to-bg">
      <div className="w-full max-w-md text-center">
        <div className="bg-panel border border-border rounded-2xl p-10">
          <div className="inline-flex w-16 h-16 rounded-full bg-blue/15 items-center justify-center mb-4">
            <AlertCircle className="w-8 h-8 text-blue-light" />
          </div>
          <h1 className="text-4xl font-black mb-2">404</h1>
          <h2 className="text-lg font-semibold mb-1">Página não encontrada</h2>
          <p className="text-sm text-muted mb-6">
            Esse caminho não existe ou você não tem permissão pra acessar.
          </p>
          <Link to="/" className="btn-primary inline-flex">
            <Home className="w-4 h-4" />
            Voltar pra home
          </Link>
        </div>
      </div>
    </div>
  );
}
